(function () {
  var standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  if (!standalone) return;

  function initializeBackButton() {
    var button = document.querySelector('[data-lexie-webapp-back]');
    if (!button) return;

    button.hidden = false;
    window.requestAnimationFrame(function () {
      button.classList.add('is-visible');
    });

    button.addEventListener('click', function () {
      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      window.location.assign(button.dataset.fallbackUrl || '/');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBackButton, { once: true });
  } else {
    initializeBackButton();
  }
})();
